// extracted by mini-css-extract-plugin
export var copyable = "_y-2";
export var explainable = "_y-1";
export var negative = "_y-3";
export var positive = "_y-4";
export var secondary = "_y-0";